import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from "@/components/ui/sonner";
import CookieBanner from "@/components/CookieBanner";
import ScrollToTop from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import WAULTCalculator from "@/pages/WAULTCalculator";
import MarktpreisRechner from "@/pages/MarktpreisRechner";
import KaeuferSuchprofil from "@/pages/KaeuferSuchprofil";
import KaeuferProfilAnsicht from "@/pages/KaeuferProfilAnsicht";
import Contact from "@/pages/Contact";
import Placeholder from "@/pages/Placeholder";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import Cookies from "@/pages/Cookies";
import FuerEigentuemer from "@/pages/FuerEigentuemer";
import FuerInvestoren from "@/pages/FuerInvestoren";
import InstitutionelleInvestoren from "@/pages/InstitutionelleInvestoren";
import FamilyOffices from "@/pages/FamilyOffices";
import Projektentwickler from "@/pages/Projektentwickler";
import Privatinvestoren from "@/pages/Privatinvestoren";
import DOIConfirmation from "@/pages/DOIConfirmation";
import Downloads from "@/pages/Downloads";
import ToolsOverview from "@/pages/ToolsOverview";
import UeberUns from "@/pages/UeberUns";
import Ersteinschaetzung from "@/pages/Ersteinschaetzung";
import LebensmittelmaerkteSeite from "@/pages/assetklassen/LebensmittelmaerkteSeite";
import DiscounterDrogerieSeite from "@/pages/assetklassen/DiscounterDrogerieSeite";
import FachmaerkteBauSeite from "@/pages/assetklassen/FachmaerkteBauSeite";
import FachmarktzentrenSeite from "@/pages/assetklassen/FachmarktzentrenSeite";
import GrossflaechenSeite from "@/pages/assetklassen/GrossflaechenSeite";
import ReadinessCheck from "@/pages/ReadinessCheck";
import RetailScore from "@/pages/RetailScore";
import VerkaufszeitpunktRadar from "@/pages/VerkaufszeitpunktRadar";
import AblaufUebersicht from "@/pages/ablauf/AblaufUebersicht";
import Phase1Unterlagen from "@/pages/ablauf/Phase1Unterlagen";
import Phase2Bewertung from "@/pages/ablauf/Phase2Bewertung";
import Phase3Vermarktung from "@/pages/ablauf/Phase3Vermarktung";
import Phase4Verhandlung from "@/pages/ablauf/Phase4Verhandlung";
import Phase5Notar from "@/pages/ablauf/Phase5Notar";
import Phase6Uebergabe from "@/pages/ablauf/Phase6Uebergabe";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/tools/wault" element={<WAULTCalculator />} />
          <Route path="/tools/marktpreis" element={<MarktpreisRechner />} />
          <Route path="/tools/readiness" element={<ReadinessCheck />} />
          <Route path="/tools/retail-score" element={<RetailScore />} />
          <Route path="/tools/verkaufszeitpunkt" element={<VerkaufszeitpunktRadar />} />
          <Route path="/ablauf" element={<AblaufUebersicht />} />
          <Route path="/kaeufer/suchprofil" element={<KaeuferSuchprofil />} />
          <Route path="/kaeufer/profil/:token" element={<KaeuferProfilAnsicht />} />

          <Route path="/ablauf/phase-1-unterlagen" element={<Phase1Unterlagen />} />
          <Route path="/ablauf/phase-2-bewertung" element={<Phase2Bewertung />} />
          <Route path="/ablauf/phase-3-vermarktung" element={<Phase3Vermarktung />} />
          <Route path="/ablauf/phase-4-verhandlung" element={<Phase4Verhandlung />} />
          <Route path="/ablauf/phase-5-notar" element={<Phase5Notar />} />
          <Route path="/ablauf/phase-6-uebergabe" element={<Phase6Uebergabe />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/ersteinschaetzung" element={<Ersteinschaetzung />} />
          
          {/* Blog Routes */}
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          
          {/* Investor Landing Pages */}
          <Route path="/investoren/institutionell" element={<InstitutionelleInvestoren />} />
          <Route path="/investoren/family-offices" element={<FamilyOffices />} />
          <Route path="/investoren/projektentwickler" element={<Projektentwickler />} />
          <Route path="/investoren/privatinvestoren" element={<Privatinvestoren />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          
          {/* Placeholder Pages */}
          <Route
            path="/fuer-eigentuemer"
            element={<FuerEigentuemer />}
          />
          <Route
            path="/fuer-investoren"
            element={<FuerInvestoren />}
          />
          <Route
            path="/tools"
            element={<ToolsOverview />}
          />
          <Route
            path="/ueber-uns"
            element={<UeberUns />}
          />
          <Route
            path="/markt-insights"
            element={
              <Placeholder
                title="Markt & Insights"
                description="Aktuelle Marktanalysen und Insights zum Handelsimmobilienmarkt."
              />
            }
          />
          
          {/* Assetklassen Pages */}
          <Route
            path="/assetklassen/lebensmittelmaerkte"
            element={<LebensmittelmaerkteSeite />}
          />
          <Route
            path="/assetklassen/discounter-drogerie"
            element={<DiscounterDrogerieSeite />}
          />
          <Route
            path="/assetklassen/fachmaerkte-bau"
            element={<FachmaerkteBauSeite />}
          />
          <Route
            path="/assetklassen/fachmarktzentren"
            element={<FachmarktzentrenSeite />}
          />
          <Route
            path="/assetklassen/grossflaechen"
            element={<GrossflaechenSeite />}
          />
          <Route
            path="/impressum"
            element={<Impressum />}
          />
          <Route
            path="/datenschutz"
            element={<Datenschutz />}
          />
          <Route
            path="/cookies"
            element={<Cookies />}
          />

          {/* DOI & Downloads */}
          <Route path="/doi/confirm/:token" element={<DOIConfirmation />} />
          <Route path="/downloads" element={<Downloads />} />

        </Routes>
        <CookieBanner />
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
    </HelmetProvider>
  );
}

export default App;